<template>
  <div class="indicators">
    <div class="indicators-container">
      <actions-buttons
        v-if="!isShownCircular && !isShownVideo"
        :hasCircular="hasCircular"
        :hasVideo="hasVideo"
        @showCircular="showCircular($event)"
        @showVideo="showVideo($event)"
      />
      <div class="progress" v-if="isShowProgress && !isShownCircular && !isShownVideo">
        <div class="thumb" :style="styleThumbIndicator"></div>
        <div class="track"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ActionsButtons from '../common/actions-buttons.vue';

interface Props {
  hasCircular?: boolean;
  hasVideo?: boolean;
  styleThumbIndicator?: { transform: string };
  isShownCircular?: boolean;
  isShownVideo?: boolean;
  isShowProgress?: boolean;
}

withDefaults(defineProps<Props>(), {
  hasCircular: false,
  hasVideo: false,
  styleThumbIndicator: () => ({ transform: '' }),
  isShownCircular: false,
  isShownVideo: false,
  isShowProgress: false,
});

const emit = defineEmits<{
  showCircular: [event: any];
  showVideo: [event: any];
}>();

function showCircular(event: any) {
  emit('showCircular', event);
}

function showVideo(event: any) {
  emit('showVideo', event);
}
</script>
<style lang="stylus" scoped>
.mobile-product-page
  .indicators
    position relative
    .indicators-container
      z-index 1
      position absolute
      bottom 16px
      left 16px
      right 16px
      display flex
      align-items center
      justify-content space-between
      .progress
        height 4px
        width 72px
        border-radius 100px
        overflow hidden
        position relative
        .thumb
          background #000
          height 100%
          width 16px
          border-radius 100px
          position absolute
          left 0
          top 0
          transition transform .3s ease-out
        .track
          background rgba(0, 0, 0, 0.15)
          height 100%
          width 100%
</style>
